module.exports = __webpack_public_path__ + "static/media/newhod.80a172b3.jpeg";